'use client';

import React, { useEffect, useRef } from 'react';

export default function ContactHero() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('[data-hero]');
    els?.forEach((el, i) => {
      const element = el as HTMLElement;
      element.style.animation = `animationIn 1s cubic-bezier(0.16,1,0.3,1) ${i * 0.1}s forwards`;
    });
  }, []);

  return (
    <section
      ref={ref}
      className="relative pt-36 pb-16 px-6 overflow-hidden"
      style={{ background: 'var(--color-bg)' }}
      aria-label="Contact page header"
    >
      {/* Accent */}
      <div
        className="absolute top-0 left-1/3 w-80 h-80 rounded-full pointer-events-none opacity-10"
        style={{ background: 'radial-gradient(circle, #52B788, transparent)' }}
      />

      <div className="max-w-4xl mx-auto text-center">
        <div data-hero className="opacity-0">
          <p className="section-label mb-4">Get Funded</p>
        </div>
        <h1
          data-hero
          className="font-display mb-5 opacity-0"
          style={{
            fontSize: 'clamp(2.5rem, 5.5vw, 4.5rem)',
            color: 'var(--color-foreground)',
            letterSpacing: '-0.025em',
            lineHeight: 1.0,
          }}
        >
          Submit Your Deal.
          <br />
          <span className="italic" style={{ color: 'var(--color-primary)' }}>
            We&apos;ll Respond in Hours.
          </span>
        </h1>
        <p
          data-hero
          className="text-lg leading-relaxed max-w-xl mx-auto opacity-0"
          style={{ color: 'var(--color-muted)' }}
        >
          Tell us about your deal and we&apos;ll come back with a funding decision — typically
          within 2–4 business hours. No lengthy intake calls required.
        </p>
      </div>
    </section>
  );
}